import Vue from 'vue'
import Router from 'vue-router'
import LayoutIn from '@/components/layouts/In'
import LayoutOut from '@/components/layouts/Out'
import Pessoa from '@/components/crud/Pessoa'
import Usuario from '@/components/crud/Usuario'
import Suporte from '@/components/crud/Suporte'
import Acesso from '@/components/crud/Acesso'
import Condominio from '@/components/crud/Condominio'
import AnoBase from '@/components/crud/AnoBase'
import Login from '@/components/auth/Login'
import Register from '@/components/auth/Register'
import Forgot from '@/components/auth/Forgot'
import Reset from '@/components/auth/Reset'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '',
      component: LayoutOut,
      children: [
        {
          path: '/',
          name: 'Login',
          component: Login,
          alias: '/login',
          meta: { title: 'Seja bem vindo!' }
        },
        {
          path: '/register',
          name: 'Register',
          component: Register,
          meta: { title: 'Registrar' }
        },
        {
          path: '/forgot',
          name: 'Forgot',
          component: Forgot,
          meta: { title: 'Esqueci minha Senha' }
        },
        {
          path: '/reset/:token',
          name: 'Reset',
          component: Reset,
          meta: { title: 'Resetar Senha' }
        }
      ]
    },
    {
      path: '',
      component: LayoutIn,
      meta: { auth: true },
      children: [
        // {
        //   path: '/home',
        //   name: 'Dashboard',
        //   component: Dashboard,
        //   meta: { title: 'Página Inicial' }
        // },
        {
          path: '/pessoa',
          name: 'Pessoa',
          component: Pessoa,
          meta: { title: 'Pessoa', access: true }
        },
        {
          path: '/condominio',
          name: 'Condominio',
          component: Condominio,
          alias: ['/home'],
          meta: { title: 'Condominio', access: true }
        },
        {
          path: '/contribuinte',
          name: 'Contribuinte',
          component: Condominio,
          meta: { title: 'Contribuinte', access: true }
        },
        {
          path: '/anobase',
          name: 'AnoBase',
          component: AnoBase,
          meta: { title: 'Ano Base', access: true }
        },
        {
          path: '/suporte',
          name: 'Suporte',
          component: Suporte,
          meta: { title: 'Suporte', access: true }
        },
        {
          path: '/usuario',
          name: 'Usuario',
          component: Usuario,
          meta: { title: 'Usuário', access: true }
        },
        {
          path: '/acesso',
          name: 'Acesso',
          component: Acesso,
          meta: { title: 'Acesso', access: true }
        }
      ]
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js